import * as React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { ArrowRight } from "lucide-react";

interface StarterProjectsModalFooterProps {
  onStartFromScratch: () => void;
  onContinue: () => void;
  isContinueDisabled: boolean;
  isStartFromScratchLoading: boolean;
  isContinueLoading: boolean;
}

export function StarterProjectsModalFooter({
  onStartFromScratch,
  onContinue,
  isContinueDisabled,
  isStartFromScratchLoading,
  isContinueLoading,
}: StarterProjectsModalFooterProps) {
  const isAnyLoading = isStartFromScratchLoading || isContinueLoading;

  return (
    <div className="absolute md:sticky w-full bottom-0 z-10 flex flex-col-reverse md:flex-row items-center md:justify-end gap-3 md:gap-4 px-6 py-4 md:py-6 md:static md:z-auto md:pt-6 md:pb-6 border-t border-border bg-white">
      <Button
        variant="secondary"
        size="lg"
        onClick={onStartFromScratch}
        disabled={isAnyLoading}
        loading={isStartFromScratchLoading}
        className="w-full md:w-fit"
      >
        Start from Scratch
      </Button>
      <Button
        variant="primary"
        size="lg"
        onClick={onContinue}
        disabled={isContinueDisabled || isAnyLoading}
        loading={isContinueLoading}
        endEnhancer={<ArrowRight />}
        className="w-full md:w-fit"
      >
        Continue
      </Button>
    </div>
  );
}
